import React, { useEffect, useState } from 'react';
import api from '../services/api';
import Toast from '../components/Toast';
import FilterableTable from '../components/FilterableTable';

export default function Magazii() {
  const [magazii, setMagazii] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editId, setEditId] = useState(null);
  const [form, setForm] = useState({ nume: '', tip: 'MATERII_PRIME', locatie: '' });
  const [toast, setToast] = useState(null);
  const [loading, setLoading] = useState(true);

  function incarca() {
    setLoading(true);
    api.get('/api/magazii').then(res => setMagazii(res.data)).finally(() => setLoading(false));
  }

  useEffect(incarca, []);

  function deschideNou() {
    setEditId(null);
    setForm({ nume: '', tip: 'MATERII_PRIME', locatie: '' });
    setShowModal(true);
  }

  function deschideEditare(m) {
    setEditId(m.id);
    setForm({ nume: m.nume, tip: m.tip, locatie: m.locatie || '' });
    setShowModal(true);
  }

  async function salveaza(e) {
    e.preventDefault();
    try {
      if (editId) {
        await api.put(`/api/magazii/${editId}`, { nume: form.nume, locatie: form.locatie });
      } else {
        await api.post('/api/magazii', { nume: form.nume, tip: form.tip, locatie: form.locatie });
      }
      setToast({ message: 'Salvat cu succes', type: 'ok' });
      setShowModal(false);
      incarca();
    } catch (err) {
      setToast({ message: err.response?.data?.error || 'Eroare la salvare', type: 'error' });
    }
  }

  async function dezactiveaza(id) {
    if (!window.confirm('Dezactivezi aceasta magazie?')) return;
    await api.delete(`/api/magazii/${id}`);
    incarca();
  }

  const coloane = [
    { key: 'cod', label: 'Cod', render: m => <strong>{m.cod}</strong> },
    { key: 'nume', label: 'Nume' },
    { key: 'tip', label: 'Tip', render: m => m.tip === 'MATERII_PRIME' ? 'Materii prime' : 'Produse finite' },
    { key: 'locatie', label: 'Locatie' },
    { key: 'activa', label: 'Status', render: m => <span className={`badge ${m.activa ? 'ok' : 'alerta'}`}>{m.activa ? 'Activa' : 'Inactiva'}</span> },
    { key: 'actiuni', label: '', filterable: false, render: m => (
      <>
        <button className="btn-edit" onClick={() => deschideEditare(m)}>Editeaza</button>{' '}
        {m.activa ? <button className="btn-delete" onClick={() => dezactiveaza(m.id)}>Dezactiveaza</button> : null}
      </>
    )}
  ];

  return (
    <div>
      <h1>Denumire magazii</h1>
      <div className="toolbar">
        <button className="btn-add" onClick={deschideNou}>+ Magazie noua</button>
      </div>

      {loading ? <p>Se incarca...</p> : <FilterableTable columns={coloane} rows={magazii} />}

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <h2>{editId ? 'Editeaza magazie' : 'Magazie noua'}</h2>
            <form onSubmit={salveaza}>
              <div className="field">
                <label>Nume *</label>
                <input value={form.nume} onChange={e => setForm({ ...form, nume: e.target.value })} required autoFocus />
              </div>
              <div className="field">
                <label>Tip {editId && '(nu se poate schimba dupa creare)'}</label>
                <select value={form.tip} onChange={e => setForm({ ...form, tip: e.target.value })} disabled={!!editId}>
                  <option value="MATERII_PRIME">Materii prime</option>
                  <option value="PRODUSE_FINITE">Produse finite</option>
                </select>
              </div>
              <div className="field">
                <label>Locatie</label>
                <input value={form.locatie} onChange={e => setForm({ ...form, locatie: e.target.value })} />
              </div>
              <div className="modal-actions">
                <button type="button" className="btn secondary" onClick={() => setShowModal(false)}>Anuleaza</button>
                <button type="submit" className="btn">Salveaza</button>
              </div>
            </form>
          </div>
        </div>
      )}

      <Toast message={toast?.message} type={toast?.type} onClose={() => setToast(null)} />
    </div>
  );
}
